"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../components/index");
const react_final_form_1 = require("react-final-form");
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const DateField = ({ name, label, validate, disabled = false, shouldDisableDate }) => (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate }, ({ input, meta }) => (react_1.default.createElement(index_1.DatePicker, { label: label, variant: "default", disabled: disabled, value: (0, moment_1.default)(input.value), onChange: (value) => input.onChange(value?.format()), error: meta.touched && meta.invalid, helperText: meta.touched && meta.error, shouldDisableDate: shouldDisableDate, fullWidth: true }))));
exports.default = DateField;
